import { render } from "./VideoGuideButton.vue?vue&type=template&id=b9e6d9b8&scoped=true"
import script from "./VideoGuideButton.vue?vue&type=script&lang=js"
export * from "./VideoGuideButton.vue?vue&type=script&lang=js"

import "./VideoGuideButton.vue?vue&type=style&index=0&id=b9e6d9b8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e6d9b8"]])

export default __exports__